import { useEditingStateWithCtx, usePagination } from '@/atoms'
import { useCallback } from 'react'

export function useEditOrderButtonData(
  extOrder: uui.domain.client.rm.ExtendedOrderStep,
  targetTab: number = 0,
) {
  const { id } = extOrder

  const { setEditing } = useEditingStateWithCtx('order')
  const { setPage: setOrderFormTab } = usePagination('orderTab')

  const editOrder = useCallback(() => {
    setEditing([id])
    setOrderFormTab(targetTab)
  }, [id, setEditing, setOrderFormTab, targetTab])

  return { editOrder }
}
